import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { Base64UrlService } from '../../../services/base64url.service';

@Component({
    selector: 'tt-edi-import',
    templateUrl: './edi-import.component.html',
    styleUrls: ['./edi-import.component.css'],
    standalone: false,
})
export class EdiImportComponent implements OnInit {
    ediImportKeyno;

    public selectedBgEdiImportMain: string = 'DETAILS';

    public edit?: Edit;

    public selectListEdiSources: Item[] = [];

    public selectListImportProcesses: Item[] = [];

    public processing = false;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private base64: Base64UrlService, private modal: ModalService, private datatask: DataTaskService) {
        this.ediImportKeyno = this.stateService.getStateParams()['edi_import_keyno'];
    }

    private async loadEdit() {
        if (!!this.ediImportKeyno) {
            const response = (await this.datatask.Post(1153, { edi_import_keyno: this.ediImportKeyno }))[0];
            this.edit = response;

            if (!!this.edit) {
                this.edit.filecontent = this.base64.Decode(response.filecontent);
            }
        }
    }

    public async loadEdiSources() {
        this.selectListEdiSources = await this.datatask.Post(978);
    }

    private async loadImportProcesses() {
        this.selectListImportProcesses = await this.datatask.Post(877, { show_in_excelimport: 'A' });
    }

    public async processChanges() {
        if (!!this.edit) {
            try {
                this.processing = true;

                const response = (await this.datatask.Post(1156, { edi_import_keyno: this.edit.edi_import_keyno }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.loadEdit();
                }
            } finally {
                this.processing = false;
            }
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1154, {
                    edi_import_keyno: this.edit.edi_import_keyno,
                    reg_datetime: this.edit.reg_datetime,
                    edi_source_keyno: this.edit.edi_source_keyno,
                    filename: this.edit.filename,
                    filecontent: this.base64.Encode(this.edit.filecontent),
                    file_created_datetime: this.edit.file_created_datetime,
                    edi_prosess_status_name: this.edit.edi_prosess_status_name,
                    prosessing_start_datetime: this.edit.prosessing_start_datetime,
                    prosessing_end_datetime: this.edit.prosessing_end_datetime,
                    p2_importproc_keyno: this.edit.p2_importproc_keyno,
                    prosessing_message: this.edit.prosessing_message,
                    reg_by_portal_user_name: this.edit.reg_by_portal_user_name,
                    prosessing_count: this.edit.prosessing_count,
                    add_type: this.edit.add_type
                }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1155, { edi_import_keyno: this.edit.edi_import_keyno }))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadEdiSources();
        this.loadImportProcesses();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    edi_import_keyno: string;
    reg_datetime: string;
    edi_source_keyno: string;
    filename: string;
    filecontent: string;
    file_created_datetime: string;
    edi_prosess_status_name: string;
    prosessing_start_datetime: string;
    prosessing_end_datetime: string;
    p2_importproc_keyno: string;
    prosessing_message: string;
    reg_by_portal_user_name: string;
    prosessing_count: string;
    add_type: string;
    processing_millisec: string;
}
